import { createRouter, createWebHashHistory } from 'vue-router';
import HomePage from '../views/HomePage.vue';
import AboutPage from '../views/About.vue';
import ParkingLots from '@/views/map/ParkingLots.vue';
import CollaborationPage from '../views/CollaborationPage.vue';
import ParkingSalePage from '../views/ParkingSalePage.vue';
import MembershipPage from '../views/MembershipPage.vue';
// import OnlinePayment from '../views/parking/OnlinePayment.vue';
import DirectParkPay from '../views/parking/DirectParkPay.vue';
import RecruitmentPage from '../views/RecruitmentPage.vue';
import DisabilityParkingPage from '../views/DisabilityParkingPage.vue';
import QuickPassPage from '../views/QuickPassPage.vue';
import LoginPage from '../views/login/LoginPage.vue';
import UserRegister from '@/views/login/UserRegister.vue';
import UserRecord from '@/views/ticket/UserLottory.vue'; 
import UserCancel from '@/views/ticket/UserCancel.vue'; 
import UserApply from '@/views/ticket/UserApply.vue';

import CardBoard from '@/views/login/CardBoard.vue';
import LPBoard from '@/views/login/LPBoard.vue';

// import TestPay from '@/views/parking/ParkPay.vue';
import ParkPay from '@/views/parking/ParkPay.vue';

import OfferCards from '@/components/home/all/OfferCards.vue';
import PrivacyPolicy from '@/views/misc/PrivacyPolicy.vue';
import QnAPage from '@/views/misc/QnAPage.vue'; // Import the new Q&A component
import ForgotPassword from '@/views/ForgotPassword.vue';
import AllNews from '@/components/home/all/AllNews.vue';
import AllPromotions from '@/components/home/all/AllPromotions.vue';
import PromotionDetail from '@/components/home/all/PromotionDetail.vue';
import NewsDetail from '@/components/home/all/NewsDetail.vue';
import ResetPassword from '@/views/login/ResetPassword.vue';
// import TestPage from '@/components/test/TestPage.vue';

// import MonthTicketPay from '@/views/ticket/monthpay/MonthTicketPay.vue';
import BillShow from '@/views/ticket/monthbill/BillShow.vue';
import { loadGoogleMaps } from '@/util/map';

const routes = [

  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
  },

  {
    path: '/month-ticket-bill',
    name: 'MonthTicketBill',
    component: BillShow,
  },

  {
    path: '/promotion-detail',
    name: 'PromotionDetail',
    component: PromotionDetail,
  },
  
  {
    path: '/news-detail',
    name: 'NewsDetail',
    component: NewsDetail,
  },

  {
    path: '/all-promotions',
    name: 'AllPromotions',
    component: AllPromotions,
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
  },
  {
    path: '/all-news',
    name: 'AllNews',
    component: AllNews,
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
  },
  { path: '/qna', name: 'QnAPage', component: QnAPage }, // New route for the Q&A page


  { path: '/offer-cards', name: 'OfferCards', component: OfferCards },

  {
    path: '/cardboard',
    name: 'CardBoard',
    component: CardBoard,
    // meta: { requiresAuth: true } // Optionally, add route guards
  },

  {
    path: '/lpboard',
    name: 'LPBoard',
    component: LPBoard,
    // meta: { requiresAuth: true } // Optionally, add route guards
  },

  
  {
    path: '/parkpay',
    name: 'ParkPay',
    component: ParkPay,
    props: true, // Enable props to pass route params as props

    // meta: { requiresAuth: true } // Optionally, add route guards
  },



  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
  },
  {
    path: '/about',
    name: 'AboutPage',
    component: AboutPage,
  },
  {
    path: '/parking-lots',
    name: 'ParkingLots',
    component: ParkingLots,
    meta: { requiresGoogleMaps: true },
  },
  {
    path: '/collaboration-page',
    name: 'CollaborationPage',
    component: CollaborationPage,
  },
  {
    path: '/parking-sale',
    name: 'ParkingSalePage',
    component: ParkingSalePage,
  },
  {
    path: '/membership-page',
    name: 'MembershipPage',
    component: MembershipPage,
  },
  {
    path: '/online-payment',
    name: 'OnlinePayment',
    component: DirectParkPay,
  },
  {
    path: '/recruitment-page',
    name: 'RecruitmentPage',
    component: RecruitmentPage,
  },
  {
    path: '/disability-parking',
    name: 'DisabilityParkingPage',
    component: DisabilityParkingPage,
  },
  {
    path: '/quick-pass',
    name: 'QuickPassPage',
    component: QuickPassPage,
  },
  {
    path: '/login-page',
    name: 'LoginPage',
    component: LoginPage,
  },
  {
    path: '/UserRegister',
    name: 'UserRegister', // 使用多词名称
    component: UserRegister // 使用 UserRegisterForm 组件
  },
  {
    path: '/UserRecord',
    name: 'UserRecord', // 更新为多词名称
    component: UserRecord // 确保使用 UserRecord 组件
  },
  {
    path: '/UserApply',
    name: 'UserApply', // 更新为多字节名称
    component: UserApply // 确保使用 UserApply 组件
  },

  {
    path: '/UserCancel',
    name: 'UserCancel', // 更新为多字节名称
    component: UserCancel // 确保使用 UserCancel 组件

  },
  {
    path: '/OnlinePayment',
    name: 'OnlinePayment',
    component: DirectParkPay
  }

];

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(), // Change to hash mode

  routes,

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // If the user is navigating back/forward, return to the saved position
      return savedPosition;
    } else {
      // Always scroll to the top for new routes
      return { top: 0 };
    }
  },
});

router.beforeEach(async (to) => {
  if (!to.meta.requiresGoogleMaps) return true;

  try {
    await loadGoogleMaps(process.env.VUE_APP_GOOGLE_MAPS_API_KEY);
    return true;
  } catch (error) {
    console.error('Failed to load Google Maps:', error);
    return false;
  }
});

export default router;
